import "./_livraisonInfo.scss";

import {useState} from "react";

import {Modale} from "@/components/Modale/Modale";
import {isPuriel} from "@/function/isPuriel";
import {Fournisseur} from "@/ts/interface/detailOffre";

function LivraisonInfo({
  fournisseurs,
}: {
  fournisseurs?: Fournisseur[];
}): JSX.Element | undefined {
  const [modale, setModale] = useState<{
    isOpen: boolean;
    title: string;
    content: string;
  }>({isOpen: false, title: "", content: ""});

  const openModale = (title: string, content: string): void => {
    setModale({isOpen: true, title: title, content: content});
  };
  if (fournisseurs) {
    const LivraisonInfo: (JSX.Element | null)[] = fournisseurs.map(
      (fournisseur, index): JSX.Element | null => {
        if (fournisseur.minimum) {
          const fraisDePort = parseFloat(fournisseur.frais_de_port.valeur);
          return (
            <div key={fournisseur.fournisseur_id + index}>
              <>
                <span>
                  {`Livraison ${fournisseur.nom} ${fraisDePort ? `(${fraisDePort.toFixed(2)} €)` : ""}`}
                </span>
                <br />
              </>

              {"Pour les commandes à partir de"}
              <span>{` ${fournisseur.minimum} unité${isPuriel(fournisseur.minimum)}`}</span>
              <div className="livraison-information--franco">
                <p>
                  {"Franco à partir de "}
                  <span>{`${parseFloat(fournisseur.franco).toFixed(2)} € `}</span>
                </p>
                {fournisseur?.commentaire ? (
                  <div
                    className="livraison-information--tooltips"
                    onClick={() =>
                      openModale(
                        `Condition franco de ${fournisseur.nom}`,
                        fournisseur?.commentaire || "",
                      )
                    }>
                    ?
                  </div>
                ) : null}
              </div>
            </div>
          );
        }
        return null;
      },
    );
    return (
      <>
        {LivraisonInfo}
        <Modale
          title={modale.title}
          isOpen={modale.isOpen}
          children={<p>{modale.content}</p>}
          close={() => setModale({...modale, isOpen: false})}
        />
      </>
    );
  }
}

export default LivraisonInfo;
